import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotSelfcareComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotSelfcare',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M13.81 2.688H10.2v5.45h3.61v-5.45Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#A26AFF",
    d: "M14 4.468h-4v1.98h4v-1.98Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M8 9.005h8V7.448c0-.55-.465-1-1.034-1H9.034c-.569 0-1.034.45-1.034 1v1.557ZM8 3.468a1 1 0 0 0 1 1H18a1 1 0 0 0 1-1v-.466a1 1 0 0 0-1-1H9c-.55 0-1 .45-1 1v.466Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#A26AFF",
    d: "M6.99 9h10.017c.89 0 1.935.774 2.143 1.858l1.841 10.18c0 .53-.43.96-.96.96H3.97a.96.96 0 0 1-.96-.96l1.83-10.18c.195-1.053 1.262-1.859 2.152-1.859Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M12 17.858c2.32 0 4.2-1.348 4.2-3.01 0-1.663-1.88-3.01-4.2-3.01-2.32 0-4.2 1.348-4.2 3.01 0 1.662 1.88 3.01 4.2 3.01Z"
  }));
};
SpotSelfcareComponent.displayName = 'SpotSelfcare';
export var SpotSelfcare = withProvisionalOverrideFromContext(SpotSelfcareComponent);
//# sourceMappingURL=index.js.map